export class ChecklistModelItemQuestion {
    id: number;
    text: string;
    description: string;
    identifier: string;
    required: boolean;
    questionOrder: number;
    type: string;
    typeValues: string;
    requiredConditionFormula: string;
    activeConditionFormula: string;
    visibilityConditionFormula: string;
    linkFormula: string;
    checklistModelItemId: number;

    constructor(checklistModelItemQuestion: any) {
        if (checklistModelItemQuestion) {
            this.id = checklistModelItemQuestion.id;
            this.text = checklistModelItemQuestion.text;
            this.description = checklistModelItemQuestion.description;
            this.identifier = checklistModelItemQuestion.identifier;
            this.required = checklistModelItemQuestion.required;
            this.questionOrder = checklistModelItemQuestion.questionOrder;
            this.type = checklistModelItemQuestion.type;
            this.typeValues = checklistModelItemQuestion.typeValues;
            this.requiredConditionFormula = checklistModelItemQuestion.requiredConditionFormula;
            this.activeConditionFormula = checklistModelItemQuestion.activeConditionFormula;
            this.visibilityConditionFormula = checklistModelItemQuestion.visibilityConditionFormula;
            this.linkFormula = checklistModelItemQuestion.linkFormula;
            this.checklistModelItemId = checklistModelItemQuestion.checklistModelItemId;
        }
    }
}
